exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-category-selector[data-v-4c42f7c1]{margin:15px 0 20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:0 15px;max-width:100%}.product-category-selector select[data-v-4c42f7c1]{padding:6px 12px;border-radius:4px;border:1px solid #ccc;background-color:#fff;min-width:200px;max-width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c42f7c1","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/ProductCategorySelector.vue
// module id = 3Z63
// module chunks = 0